import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Deliberately createRoot, not hydrateRoot: this app's MUI/Emotion styling
// generates class names that aren't guaranteed identical between the
// build-time prerender pass (scripts/prerender.js) and a fresh browser
// render, which produced real React hydration-mismatch errors (#418/#423)
// when tested with hydrateRoot. createRoot has no such risk — React simply
// clears the prerendered root and renders fresh, its normal, fully
// supported behavior when a root container already has children. The
// prerendered markup still does its job for any crawler or tool that
// doesn't execute JavaScript; real browsers briefly show the prerendered
// content and then render normally, same as before this change.
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
